(function () {
  if (window.LEGUInfiniteCollectionController) {
    window.LEGUInfiniteCollectionController.refresh();
    return;
  }

  var controller = {
    pagination: null,
    nextLink: null,
    button: null,
    loader: null,
    section: null,
    observer: null,
    observerTarget: null,
    fetchController: null,
    buttonHandler: null,
    mutationObserver: null,
    refreshScheduled: false,
    isLoading: false,
    generation: 0,

    getProductContainer: function (root) {
      return root.querySelector('.legu-promo-grid-list')
        || root.querySelector('.collection-listing .product-grid');
    },

    getListingState: function (url) {
      var parsedUrl = new URL(url, window.location.origin);
      var state = [];

      parsedUrl.searchParams.forEach(function (value, key) {
        if (key.indexOf('filter.') === 0 || key === 'sort_by') {
          state.push(key + '=' + value);
        }
      });

      return parsedUrl.pathname + '?' + state.sort().join('&');
    },

    belongsToCurrentListing: function (url) {
      return this.getListingState(url) === this.getListingState(window.location.href);
    },

    setLoading: function (state) {
      this.isLoading = state;

      if (this.button) {
        this.button.disabled = state;
        this.button.style.display = state ? 'none' : '';
      }

      if (this.loader) {
        this.loader.style.display = state ? 'block' : 'none';
      }
    },

    destroyInstance: function () {
      this.generation += 1;

      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      }

      if (this.fetchController) {
        this.fetchController.abort();
        this.fetchController = null;
      }

      if (this.button && this.buttonHandler) {
        this.button.removeEventListener('click', this.buttonHandler);
      }

      if (this.observerTarget && this.observerTarget.parentNode) {
        this.observerTarget.parentNode.removeChild(this.observerTarget);
      }

      document.querySelectorAll('.legu-infinite-observer').forEach(function (target) {
        target.remove();
      });

      this.pagination = null;
      this.nextLink = null;
      this.button = null;
      this.loader = null;
      this.section = null;
      this.observerTarget = null;
      this.buttonHandler = null;
      this.isLoading = false;
    },

    loadNextPage: function () {
      var self = this;

      if (this.isLoading || !this.nextLink || !this.nextLink.href) return;

      if (!this.belongsToCurrentListing(this.nextLink.href)) {
        this.refresh();
        return;
      }

      var requestGeneration = this.generation;
      var requestedUrl = this.nextLink.href;
      this.fetchController = new AbortController();
      this.setLoading(true);

      fetch(requestedUrl, { signal: this.fetchController.signal })
        .then(function (response) {
          if (!response.ok) {
            throw new Error('HTTP error! Status: ' + response.status);
          }
          return response.text();
        })
        .then(function (html) {
          if (
            requestGeneration !== self.generation
            || !self.pagination
            || !self.pagination.isConnected
            || !self.belongsToCurrentListing(requestedUrl)
          ) {
            return;
          }

          var doc = new DOMParser().parseFromString(html, 'text/html');
          var currentContainer = self.getProductContainer(self.section || document);
          var nextContainer = self.getProductContainer(doc);

          if (!currentContainer || !nextContainer) {
            self.setLoading(false);
            return;
          }

          Array.prototype.slice.call(nextContainer.children).forEach(function (item) {
            currentContainer.appendChild(item);
          });

          var newNextLink = doc.querySelector('.legu-infinite-next');

          if (newNextLink && newNextLink.href && self.belongsToCurrentListing(newNextLink.href)) {
            self.nextLink.href = newNextLink.href;
            self.fetchController = null;
            self.setLoading(false);
          } else {
            var completedPagination = self.pagination;
            self.destroyInstance();
            if (completedPagination && completedPagination.parentNode) {
              completedPagination.parentNode.removeChild(completedPagination);
            }
          }
        })
        .catch(function (error) {
          if (error.name !== 'AbortError' && requestGeneration === self.generation) {
            self.fetchController = null;
            self.setLoading(false);
          }
        });
    },

    initInstance: function () {
      var self = this;
      var pagination = document.querySelector('.legu-infinite-pagination');

      if (!pagination) return;

      var nextLink = pagination.querySelector('.legu-infinite-next');
      if (!nextLink || !nextLink.href || !this.belongsToCurrentListing(nextLink.href)) return;

      this.pagination = pagination;
      this.nextLink = nextLink;
      this.button = pagination.querySelector('.legu-infinite-button');
      this.loader = pagination.querySelector('.legu-infinite-loader');
      this.section = pagination.closest('[data-section-id]') || document;
      this.generation += 1;

      this.buttonHandler = function () {
        self.loadNextPage();
      };

      if (this.button) {
        this.button.addEventListener('click', this.buttonHandler);
      }

      this.observerTarget = document.createElement('div');
      this.observerTarget.className = 'legu-infinite-observer';
      pagination.parentNode.insertBefore(this.observerTarget, pagination);

      this.observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            self.loadNextPage();
          }
        });
      }, { rootMargin: '600px 0px' });

      this.observer.observe(this.observerTarget);
    },

    refresh: function () {
      this.destroyInstance();
      this.initInstance();
    },

    mutationTouchesPagination: function (mutation) {
      if (
        mutation.target.nodeType === 1
        && mutation.target.closest('.legu-infinite-pagination')
      ) {
        return true;
      }

      var changedNodes = Array.prototype.slice.call(mutation.addedNodes)
        .concat(Array.prototype.slice.call(mutation.removedNodes));

      return changedNodes.some(function (node) {
        return node.nodeType === 1 && (
          node.matches('.legu-infinite-pagination')
          || node.querySelector('.legu-infinite-pagination')
        );
      });
    },

    scheduleRefresh: function () {
      var self = this;
      if (this.refreshScheduled) return;

      this.refreshScheduled = true;
      window.requestAnimationFrame(function () {
        self.refreshScheduled = false;
        self.refresh();
      });
    },

    start: function () {
      var self = this;
      this.refresh();

      this.mutationObserver = new MutationObserver(function (mutations) {
        if (mutations.some(function (mutation) {
          return self.mutationTouchesPagination(mutation);
        })) {
          self.scheduleRefresh();
        }
      });

      this.mutationObserver.observe(document.documentElement, {
        childList: true,
        subtree: true
      });

      document.addEventListener('shopify:section:load', function () {
        self.scheduleRefresh();
      });
    }
  };

  window.LEGUInfiniteCollectionController = controller;
  window.LEGUInfiniteCollectionLoaded = true;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      controller.start();
    });
  } else {
    controller.start();
  }
})();
